import React from "react";
import { motion } from "framer-motion";

const GRADIENTS = {
  standard: "radial-gradient(circle at 35% 30%, #ffffff 0%, #0055C6 45%, #002B66 100%)",
  loto: "radial-gradient(circle at 35% 30%, #ffffff 0%, #0055C6 45%, #002B66 100%)",
  euromillions: "radial-gradient(circle at 35% 30%, #DCE7FF 0%, #1B3B8B 50%, #0B1E52 100%)",
  eurodreams: "radial-gradient(circle at 35% 30%, #F3E8FF 0%, #7C3AED 48%, #4C1D95 100%)",
  keno: "radial-gradient(circle at 35% 30%, #FDE7EE 0%, #9B1B3A 48%, #5E0A24 100%)",
  star: "radial-gradient(circle at 35% 30%, #FFFBEB 0%, #F59E0B 45%, #B45309 100%)",
  chance: "radial-gradient(circle at 35% 30%, #FEE2E2 0%, #EF4444 45%, #991B1B 100%)",
  dream: "radial-gradient(circle at 35% 30%, #F3E8FF 0%, #9333EA 45%, #581C87 100%)",
};

export const LotteryBall = ({ number, variant = "standard", size = "md", delay = 0, animate = true, testId }) => {
  const dims =
    size === "sm"
      ? "w-9 h-9 text-sm"
      : size === "lg"
      ? "w-14 h-14 text-xl"
      : "w-11 h-11 sm:w-12 sm:h-12 text-base sm:text-lg";
  const bg = GRADIENTS[variant] || GRADIENTS.standard;
  const isLight = variant === "star" || variant === "chance";
  const Comp = animate ? motion.div : "div";
  const motionProps = animate
    ? {
        initial: { scale: 0, rotate: -180, opacity: 0 },
        animate: { scale: 1, rotate: 0, opacity: 1 },
        transition: { type: "spring", stiffness: 260, damping: 18, delay },
      }
    : {};
  return (
    <Comp
      {...motionProps}
      data-testid={testId}
      className={`${dims} rounded-full flex items-center justify-center font-black text-white shadow-md border border-white/40 select-none relative overflow-hidden`}
      style={{ background: bg, textShadow: "0 1px 2px rgba(0,0,0,0.35)" }}
    >
      <span className="relative z-10">{number}</span>
      <span className="absolute top-1 left-2 w-4 h-2 rounded-full bg-white/50 blur-[1px]" />
    </Comp>
  );
};
